import axiosInstance from './AxiosInstance';

const API_URL = 'contractlocations';

export const getContractLocations = async () => {
    try {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error contract location list', error);
        throw error;
    }
};

export const getContractLocationById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/view/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching contract location with id ${id}`, error);
        throw error;
    }
};

export const createContractLocation = async (contractLocation) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/add`, contractLocation);
        return response.data;
    } catch (error) {
        console.error('Error creating contract location', error);
        throw error;
    }
};

export const updateContractLocation = async (id, contractLocation) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...contractLocation });
        return response.data;
    } catch (error) {
        console.error(`Error updating contract location with id ${id}`, error);
        throw error;
    }
};

export const deleteContractLocation = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete/`, { id: id });
        return response.data;
    } catch (error) {
        console.error(`Error deleting contract location with id ${id}`, error);
        throw error;
    }
};

